import {
  INDEX_PAGES,
  SEARCH_RESULT_ATTRIBUTES_FEATURE,
  INDEX_PAGES_SUGGESTIONS,
  SEARCH_RESULT_ATTRIBUTES_SUGGESTIONS,
  INDEX_COLLECTIONS,
  SEARCH_RESULT_ATTRIBUTES_SIMPLE,
} from '@/constants/search'
import { algoliaClient } from '@/clients/algolia'
import env from '@/constants/env'

const FEATURED_HITS_PER_PAGE = 6
const SUGGESTIONS_HITS_PER_PAGE = 4
const COLLECTIONS_HITS_PER_PAGE = 2

const FILTER_OUT_PRODUCT_COLLECTIONS = env.PUBLIC_ENABLE_PRODUCT_COLLECTIONS_IN_SEARCH !== 'true'

export const getSearchModalResults = async (query: string) => {
  const { results } = await algoliaClient.multipleQueries([
    {
      indexName: INDEX_PAGES,
      query: query,
      params: {
        hitsPerPage: FEATURED_HITS_PER_PAGE,
        attributesToRetrieve: SEARCH_RESULT_ATTRIBUTES_FEATURE,
      },
    },
    {
      indexName: INDEX_PAGES_SUGGESTIONS,
      query: query,
      params: {
        attributesToHighlight: ['query'],
        hitsPerPage: SUGGESTIONS_HITS_PER_PAGE,
        attributesToRetrieve: SEARCH_RESULT_ATTRIBUTES_SUGGESTIONS,
      },
    },
    {
      indexName: INDEX_COLLECTIONS,
      query: query,
      params: {
        hitsPerPage: COLLECTIONS_HITS_PER_PAGE,
        attributesToHighlight: ['title'],
        attributesToRetrieve: SEARCH_RESULT_ATTRIBUTES_SIMPLE,
        ...(FILTER_OUT_PRODUCT_COLLECTIONS && {
          filters: 'NOT _type:page.product.collection',
        }),
      },
    },
  ])

  return results
}
